"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billOfMaterials = billOfMaterials;
exports.getAvailableOpAmps = getAvailableOpAmps;
exports.getCircuitDesignModel = getCircuitDesignModel;
exports.getCircuitGraphData = getCircuitGraphData;
exports.getResult = getResult;
exports.getSchematicFromInput = getSchematicFromInput;
exports.setModelError = setModelError;
var _modelError = _interopRequireDefault(require("./models/model-error"));
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
var _stages = require("./stages");
var Graphs = _interopRequireWildcard(require("./graphs"));
var Common = _interopRequireWildcard(require("./common"));
var StepResponse = _interopRequireWildcard(require("./step-response"));
var Recommendations = _interopRequireWildcard(require("./recommendations"));
var NextSteps = _interopRequireWildcard(require("./next-steps"));
var Solver = _interopRequireWildcard(require("./solver"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import ErrorCodes from "./error-codes";

function getAvailableOpAmps(opAmpDb, Vr, Bias, Cd, Rsh, Ip, sensor, peakVoltage, speed, peaking, numberOfStages, stage1OpAmpName, stageIndex) {
  return Recommendations.getAvailableOpAmps(opAmpDb, Vr, Bias, Cd, Rsh, Ip, sensor, peakVoltage, speed, peaking, numberOfStages, stage1OpAmpName, stageIndex);
}
function billOfMaterials(stagesObject, stagesPreference, sensor) {
  return NextSteps.billOfMaterials(stagesObject, stagesPreference, sensor);
}
function getCircuitDesignModel(inputValues, opAmpDB) {
  var results;
  if (inputValues.stages === _photodiodeConstants.default.pdStages.oneStage) {
    if (inputValues.opAmps && inputValues.opAmps.length > 0 && inputValues.opAmps[0] !== null && inputValues.opAmps[0] !== undefined) {
      results = (0, _stages.calculateOneStage_FixedOpAmp)(inputValues, opAmpDB);
    } else {
      results = (0, _stages.calculateOneStage_FindOpAmp)(inputValues, opAmpDB);
    }
  } else {
    if (inputValues.opAmps && inputValues.opAmps.length > 0 && inputValues.opAmps[0] !== null && inputValues.opAmps[0] !== undefined) results = (0, _stages.calculateTwoStages_FixedOpAmp)(inputValues, opAmpDB);else {
      results = (0, _stages.calculateTwoStages_FindOpAmp)(inputValues, opAmpDB);
    }
  }
  if (results instanceof _modelError.default) return results;
  return {
    stage1: results.stage1,
    stage2: results.stage2
  };
}
function getCircuitGraphData(inputValues, opAmpDB, stagesObject) {
  var roughBW = Graphs.getRoughBW(stagesObject);
  var magnitudeArray = [],
    frequencyArray = [],
    //startFrequency = inputValues.speed / 100,
    //stopFrequency = inputValues.speed * 1000,
    startFrequency = roughBW / 100,
    stopFrequency = roughBW * 100,
    dynamicRangeObj = {};

  // calculate frequency
  const decade = Math.log10(stopFrequency) - Math.log10(startFrequency);
  frequencyArray = Common.friendlyFrequency(startFrequency, stopFrequency, decade);

  //calculate magnitude
  magnitudeArray = Graphs.createMagnitudeArray(frequencyArray, stagesObject, inputValues);

  //               var stepResponseResults = AdiCm.PD.lib.StepResponse.stepResponse(inputValues, opAmpDB, stagesObject);
  var stepResponseResults = StepResponse.pulseResponse(inputValues, opAmpDB, stagesObject);
  var timeAxis = stepResponseResults[0];
  var stepResponseArray = stepResponseResults[1];
  var riseTime = stepResponseResults[2];
  var overshoot = stepResponseResults[3];
  var vPeak = inputValues.peakVoltage;
  var noiseResults = Graphs.calculateNoise(frequencyArray, stagesObject); //Use the outputs for the "Noise Contributors" in the SNR tab 
  //noiseResults.total also used for Minimum Signal - Noise Floor
  var minPhotoCurrent = noiseResults.total / vPeak * inputValues.peakCurrent; //Use for Minimum Signal - Photodiode Current 
  //calculate quick results
  var snr = Graphs.calculateSNR(noiseResults.total, vPeak);
  var enob = Graphs.calculateENOB(snr);
  var outputOffset = Solver.calculateOutputOffset(stagesObject);
  dynamicRangeObj = {
    snr: snr,
    enob: enob,
    outputOffset: outputOffset,
    noise: noiseResults,
    minPhotoCurrent: minPhotoCurrent
  };
  return {
    stagesObject: stagesObject,
    frequency: frequencyArray,
    magnitude: magnitudeArray,
    timeAxis: timeAxis,
    stepResponse: stepResponseArray,
    riseTime: riseTime,
    overshoot: overshoot,
    dynamicRange: dynamicRangeObj
  };
}
function getResult(opampDb, Vr, Bias, Cd, Rsh, Ip, sensor, peakVoltage, speed, peaking, numberOfStages, opamp1, opamp2, requireRecommended /*, isFirstTime*/) {
  let opAmps = [opamp1, opamp2];
  let inputValues = {
    sensor: sensor,
    reverseVoltage: Vr,
    biasPreference: Bias,
    capacitance: Cd,
    shuntResistance: Rsh,
    peakCurrent: Ip,
    peakVoltage: peakVoltage,
    speed: speed,
    peaking: peaking,
    stages: numberOfStages,
    opAmps: opAmps,
    requireRecommended: requireRecommended
  };
  let circuitData = this.getCircuitDesignModel(inputValues, opampDb);
  if (circuitData instanceof _modelError.default) return circuitData;
  let graphData = this.getCircuitGraphData(inputValues, opampDb, circuitData);
  return graphData;
}
function getSchematicFromInput(Vr, Bias, Cd, Rsh, Ip, Photodiode) {
  let vBias = Bias == '-' ? -Vr : Vr;
  let circuitName = Bias == '-' ? _photodiodeConstants.default.pdCircuits.oneStageNegative : _photodiodeConstants.default.pdCircuits.oneStagePositive;
  return {
    vr: Vr,
    vBias: vBias,
    cd: Cd,
    rsh: Rsh,
    ip: Ip,
    photodiodeName: Photodiode,
    circuitName: circuitName
  };
}
function setModelError(errorObject) {
  return errorObject.errorParameter ? new _modelError.default(errorObject.errorCode, errorObject.errorParameter) : new _modelError.default(errorObject.errorCode);
}